import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {LocalStorageService} from "angular-web-storage";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private readonly localStorage: LocalStorageService,
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        try {
            const usuario = this.localStorage.get('usuario');
            if (usuario && usuario.token) {
                const req1 = req.clone({
                    headers: req.headers.set('Authorization', `Bearer ${usuario.token}`),
                });
                return next.handle(req1);
            }
            return next.handle(req);
        } catch (error) {
            return next.handle(req);
        }
    }

}
